import Dialog, {
  DialogActionButton,
  DialogActions,
  DialogContent,
  DialogContentTitle
} from 'components/Dialog';
import Text from 'components/Text';
import { useAppContext } from 'hooks/useAppContext';

type MigratedToScaffoldingDialogProps = {
  open: boolean;
  embedId: string;
};

// Locks the legacy editor once scaffolding owns the form: no close button,
// backdrop and escape are ignored, the only ways out are the two links
export const MigratedToScaffoldingDialog = ({
  open,
  embedId
}: MigratedToScaffoldingDialogProps) => {
  const { envConfig } = useAppContext();
  const editUrl = `${envConfig?.gmsBaseUrl}/scaffolding/edit/${embedId}`;
  const allFormsUrl = `${envConfig?.gmsBaseUrl}/g/fundraising/embeds`;

  return (
    <Dialog
      label="migrated to scaffolding dialog"
      open={open}
      onClose={() => undefined}
    >
      <DialogContent>
        <DialogContentTitle>
          Your form now lives in the new editor
        </DialogContentTitle>
        <Text variant="body">
          We&apos;ve moved this form to our unified editor, where you can manage
          all your giving forms in one place. Your content and settings came
          with it.
        </Text>
      </DialogContent>
      <DialogActions>
        <DialogActionButton
          variant="primary"
          onClick={() => window.location.assign(editUrl)}
        >
          Edit Form
        </DialogActionButton>
        <DialogActionButton
          variant="secondary"
          onClick={() => window.location.assign(allFormsUrl)}
        >
          See All Forms
        </DialogActionButton>
      </DialogActions>
    </Dialog>
  );
};
